export default __webpack_public_path__ + "static/media/choose_from_library.b3ad70c0.svg";